import request from "@/untils/request.js"

// 诊所科室统计
export const otpatDept = (params) => {
    return request.get("/outpatient/ostatis/otpatDept", { params } )
}

// 门诊医嘱处置-统计
export const disposeStatis = (params) => {
    return request.get("/outpatient/doctordispose/disposeStatis", { params } )
}
